module.exports = __webpack_public_path__ + "7d088296/img/pwrd-by-sourcery-black.bba9ba41.svg";